import { Component, inject } from '@angular/core';
import { EmailSettings } from '../../../shared/models/generated/ziroModels';
import { ZiroIcons } from '../../../shared/models/ziro-icons.enum';
import { ZiroFormConfig, ZiroFormsValidationState } from '../../../forms/ziro-forms-models';
import { Observable } from 'rxjs';
import { ToastService } from '../../../shared/services/toast.service';
import { ToastTypes } from '../../../shared/services/abstract/toast.service.abstract';
import { HtmlInputType, ZiroTextConfig } from '../../../forms/fields/text/ziro-text.component';
import { EmailSettingsContext } from '../../../shared/contexts/email-settings.context';
import { ZiroFormStateService } from '../../../forms/ziro-form-state.service';
import { ModalBodyClass } from '../../../modals/modal-body';
import { PromptModalComponent } from '../../../modals/prompt-modal/prompt-modal.component';

interface ModalViewProperties {
  emailSettings: EmailSettings;
  emailAddress: string;
}

@Component({
  selector: 'ziro-admin-email-configuration-modal',
  templateUrl: './admin-email-configuration-modal.component.html',
  standalone: false,
})
export class AdminEmailConfigurationModalComponent extends ModalBodyClass {
  private emailSettingsContext = inject(EmailSettingsContext);
  private toastService = inject(ToastService);
  protected _ziroFormStateService: ZiroFormStateService;
  private modalComponent = inject<PromptModalComponent<any>>(PromptModalComponent);

  modalViewProperties: ModalViewProperties;
  ziroIcons = ZiroIcons;

  formConfig = {
    fields: {
      emailAddress: {
        componentConfig: new ZiroTextConfig({
          htmlInputType: HtmlInputType.TEXT,
          placeholder: 'Ex. jsmith@goziro.com',
        }),
        dataAutomation: 'email-config-modal-email-input',
        required: true,
        validation: [
          {
            validator: (val: string) =>
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                val,
              )
                ? ZiroFormsValidationState.VALID
                : ZiroFormsValidationState.INVALID,
            message: 'tkey;admin.email_configuration.modal.email.validator.message',
          },
        ],
      },
    },
  } as ZiroFormConfig;

  submit(): Observable<boolean> {
    return this._onFormSubmit();
  }

  _onFormSubmit(): Observable<boolean> {
    const enteredEmailAddress = this.formData.emailAddress;
    return new Observable<boolean>((subscriber) => {
      this.emailSettingsContext
        .test({
          ...this.modalComponent.modalViewProperties.emailSettings,
          emailAddress: enteredEmailAddress,
        })
        .subscribe({
          next: () => {
            this.emailSettingsContext.put(this.modalComponent.modalViewProperties.emailSettings).subscribe(() => {
              this.toastService.push(
                ToastTypes.SUCCESS,
                this.ziroIcons.INBOX,
                'tkey;shared.toast.save.success.title',
                'tkey;admin.email_configuration.toast.success.message',
              );
              subscriber.next(true);
              subscriber.complete();
            });
          },
          error: () => {
            this.toastService.push(
              ToastTypes.ERROR,
              this.ziroIcons.INBOX,
              'tkey;admin.email_configuration.toast.error.title',
              'tkey;admin.email_configuration.toast.error.message',
            );
            subscriber.next(false);
            subscriber.complete();
          },
        });
    });
  }
}
